<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :viewBox="viewBox"
  >
    <g data-name="レイヤー 5">
      <g data-name="グループ 12680">
        <path
          data-name="パス 5093"
          d="M543.333 656h-14.666a.666.666 0 0 0-.667.667v14.667a.666.666 0 0 0 .667.667h14.667a.666.666 0 0 0 .667-.667v-14.667a.666.666 0 0 0-.668-.667zm-12.667 7.333h-1.333v-2.667h1.333zm-1.333 1.333h1.333v2.667h-1.333zm2.667-7.333h8v13.333h-8zm9.333 3.333h1.333v2.667h-1.333zm0 4h1.333v2.667h-1.333zm1.333-5.333h-1.333v-2h1.333zm-12-2v2h-1.333v-2zm-1.333 11.333h1.333v2h-1.333zm12 2v-2h1.333v2z"
          transform="translate(-528 -656)"
          :style="{ fill: color }"
        />
        <path
          data-name="パス 5094"
          d="m541.037 665.779-4-2.667a.667.667 0 0 0-1.037.555V669a.667.667 0 0 0 1.037.555l4-2.667a.667.667 0 0 0 0-1.109zm-3.7 1.976v-2.843l2.131 1.421z"
          transform="translate(-530.667 -658.333)"
          :style="{ fill: color }"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'MovieFileSVG',
  props: {
    size: {
      type: String,
      default: '16px',
    },
    viewBox: {
      type: String,
      default: '0 0 16 16',
    },
    color: {
      type: String,
      default: '#989898',
    },
  },
};
</script>
